import { Button, squareBlockCSS, styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, css, Stack, styled } from '@mui/material';

import { PromoBannerProps } from './types';

type SContainerProps = {
  $variant?: PromoBannerProps['variant'];
};

export const SContainer = styled(
  Stack,
  styledOmitCustomProps,
)<SContainerProps>(
  ({ theme, $variant = 'grey' }) => css`
    padding: 12px;
    background-color: ${theme.palette[$variant][50]};
    border-radius: 10px;
    gap: 8px;
    flex-direction: row;
    position: relative;
    min-width: 182px;

    ${theme.breakpoints.up('tablet')} {
      flex-direction: column;
      gap: 12px;
    }
  `,
);

type SIconContainerProps = {
  $variant?: PromoBannerProps['variant'];
};

export const SIconContainer = styled(
  Box,
  styledOmitCustomProps,
)<SIconContainerProps>(
  ({ theme, $variant = 'grey' }) => css`
    ${squareBlockCSS(32)};
    border-radius: 50%;
    background-color: ${theme.palette[$variant][100]};
    color: ${theme.palette[$variant][600]};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      ${squareBlockCSS(16)};
    }
  `,
);

type SCloseButtonProps = {
  $color?: PromoBannerProps['variant'];
};
export const SCloseButton = styled(
  Button,
  styledOmitCustomProps,
)<SCloseButtonProps>(
  ({ theme, $color = 'grey' }) => css`
    position: absolute;
    right: 12px;
    top: 12px;

    .MuiButton-icon svg {
      color: ${theme.palette[$color][300]};
    }

    &:hover {
      .MuiButton-icon svg {
        color: ${theme.palette[$color][500]};
      }
    }
  `,
);
